/**
 * Live screens that still showed Hangul chips/labels: shorts neighbor cats, checkout, restaurant detail.
 */

function pick(map, langIndex) {
  const out = {};
  Object.entries(map).forEach(([k, v]) => {
    if (Array.isArray(v) && v.length >= 4) out[k] = v[langIndex];
    else if (v && typeof v === 'object' && !Array.isArray(v)) out[k] = pick(v, langIndex);
    else out[k] = v;
  });
  return out;
}

const shorts = {
  catFood: ['맛집', 'Food', 'Ẩm thực', 'Еда'],
  catInfo: ['생활정보', 'Local info', 'Thông tin sống', 'Быт'],
  catDaily: ['일상', 'Daily', 'Đời thường', 'Будни'],
  catTravel: ['여행', 'Travel', 'Du lịch', 'Путешествия'],
  catPet: ['반려동물', 'Pets', 'Thú cưng', 'Питомцы'],
  catBeauty: ['뷰티', 'Beauty', 'Làm đẹp', 'Красота'],
  catTip: ['꿀팁', 'Tips', 'Mẹo hay', 'Советы'],
  catHumor: ['유머', 'Humor', 'Hài hước', 'Юмор'],
};

const payPage = {
  title: ['결제하기', 'Pay', 'Thanh toán', 'Оплата'],
  product: ['결제 상품', 'Item', 'Sản phẩm', 'Товар'],
  subPlan: ['구독 플랜 ({tier})', 'Plan ({tier})', 'Gói ({tier})', 'План ({tier})'],
  amount: ['금액: {amount}', 'Amount: {amount}', 'Số tiền: {amount}', 'Сумма: {amount}'],
  method: ['결제 수단', 'Payment method', 'Phương thức', 'Способ оплаты'],
  card: ['카드 결제', 'Card', 'Thẻ', 'Карта'],
  bank: ['계좌 이체', 'Bank transfer', 'Chuyển khoản', 'Перевод'],
  wallet: ['전자지갑', 'E-wallet', 'Ví điện tử', 'Кошелёк'],
  pointDiscount: ['밍고 포인트 할인 사용 ($1.00)', 'Use Mingo points ($1.00)', 'Dùng điểm Mingo ($1.00)', 'Баллы Mingo ($1.00)'],
  finalAmount: ['최종 금액: {amount}', 'Total: {amount}', 'Tổng: {amount}', 'Итого: {amount}'],
  processing: ['처리 중...', 'Processing…', 'Đang xử lý…', 'Обработка…'],
  missing: ['결제 정보가 없습니다.', 'No payment details.', 'Thiếu thông tin thanh toán.', 'Нет данных оплаты.'],
  error: ['결제 처리 중 오류가 발생했습니다.', 'Payment failed.', 'Thanh toán lỗi.', 'Ошибка оплаты.'],
};

const restaurant = {
  menuSet: ['세트', 'Set', 'Combo', 'Сет'],
  menuDrink: ['음료', 'Drinks', 'Đồ uống', 'Напитки'],
  menuDessert: ['디저트', 'Dessert', 'Tráng miệng', 'Десерт'],
  photoCounter: ['사진 {cur}/{total}', 'Photo {cur}/{total}', 'Ảnh {cur}/{total}', 'Фото {cur}/{total}'],
  hoursLine: ['평일 {weekday} / 주말 {weekend}', 'Weekdays {weekday} / Weekend {weekend}', 'Ngày thường {weekday} / Cuối tuần {weekend}', 'Будни {weekday} / Выходные {weekend}'],
  payCash: ['현금', 'Cash', 'Tiền mặt', 'Наличные'],
  payCard: ['카드', 'Card', 'Thẻ', 'Карта'],
  parkingOk: ['가능', 'Available', 'Có', 'Есть'],
  parkingNo: ['불가', 'No', 'Không', 'Нет'],
  contactTitle: ['SNS / 연락처', 'Social / contact', 'MXH / liên hệ', 'Соцсети / контакты'],
  call: ['전화', 'Call', 'Gọi', 'Звонок'],
  kakao: ['카카오', 'KakaoTalk', 'KakaoTalk VN', 'Какао'],
  kakaoToast: ['카카오: {id}', 'KakaoTalk: {id}', 'KakaoTalk VN: {id}', 'Какао: {id}'],
  website: ['웹사이트', 'Website', 'Trang web', 'Веб-сайт'],
  instagram: ['인스타', 'Instagram', 'Insta', 'Инстаграм'],
  addCart: ['담기', 'Add', 'Thêm', 'В корзину'],
  linkCopied: ['링크를 복사했어요.', 'Link copied.', 'Đã sao chép liên kết.', 'Ссылка скопирована.'],
  cartSoon: ['장바구니 기능 준비중입니다.', 'Cart is coming soon.', 'Giỏ hàng sắp có.', 'Корзина скоро.'],
  writeReview: ['리뷰 작성하기', 'Write a review', 'Viết đánh giá', 'Написать отзыв'],
  writeReviewTitle: ['리뷰 작성', 'Write a review', 'Viết đánh giá', 'Отзыв'],
  reviewPh: ['방문 후기를 남겨주세요', 'Share your visit', 'Chia sẻ trải nghiệm', 'Напишите впечатление'],
  reviewSubmit: ['리뷰 등록', 'Post review', 'Đăng đánh giá', 'Опубликовать'],
  reviewSubmitting: ['등록 중...', 'Posting…', 'Đang đăng…', 'Публикация…'],
  reviewOk: ['리뷰가 등록되었습니다', 'Review posted', 'Đã đăng đánh giá', 'Отзыв опубликован'],
  reviewFail: ['리뷰 등록에 실패했습니다', 'Could not post review', 'Không đăng được', 'Не удалось опубликовать'],
  googleMaps: ['구글맵', 'Google Maps', 'Bản đồ Google', 'Карты Google'],
  naverMaps: ['네이버지도', 'Naver Map', 'Bản đồ Naver', 'Карта Naver'],
  inquire: ['문의하기', 'Inquire', 'Hỏi', 'Спросить'],
  callBtn: ['전화하기', 'Call', 'Gọi', 'Позвонить'],
  order: ['주문하기', 'Order', 'Đặt món', 'Заказать'],
  reserve: ['예약하기', 'Reserve', 'Đặt bàn', 'Бронь'],
  inquiryMsg: ['안녕하세요, 문의드립니다.', 'Hello, I have a question.', 'Xin chào, tôi muốn hỏi.', 'Здравствуйте, хочу уточнить.'],
  inquirySent: ['문의가 전송되었습니다', 'Inquiry sent', 'Đã gửi câu hỏi', 'Запрос отправлен'],
  inquirySoon: ['문의하기는 준비중입니다', 'Inquiries coming soon', 'Tính năng hỏi sắp có', 'Запросы скоро'],
  noShowBlock: [
    '노쇼 기록이 3회 이상으로 예약이 제한됩니다. 고객센터에 문의하세요.',
    'Booking is restricted after 3 no-shows. Contact support.',
    'Bị hạn chế đặt bàn vì no-show ≥ 3. Liên hệ hỗ trợ.',
    'Бронь ограничена после 3 no-show. Напишите в поддержку.',
  ],
  noShowTitle: ['노쇼 주의사항', 'No-show policy', 'Quy định no-show', 'Правила no-show'],
  noShowBody1: ['예약 후 방문하지 않으면 노쇼로 기록됩니다.', 'Missing a booking is recorded as a no-show.', 'Không đến sẽ bị ghi no-show.', 'Неявка фиксируется как no-show.'],
  noShowBody2: [
    '노쇼 3회 이상 시 예약 기능이 제한될 수 있습니다.',
    '3 or more no-shows may restrict booking.',
    'Từ 3 lần no-show có thể bị hạn chế đặt bàn.',
    '3 и более no-show могут ограничить бронь.',
  ],
};

const local = {
  filterKo: ['한국어가능', 'Korean OK', 'Nói được tiếng Hàn', 'Говорят по-корейски'],
  filterVerified: ['인증업체', 'Verified', 'Đã xác minh', 'Проверенные'],
  filterRating: ['평점순', 'Top rated', 'Điểm cao', 'По рейтингу'],
  emptyHint: ['다른 검색어 또는 필터를 시도해보세요.', 'Try another search or filter.', 'Thử từ khoá hoặc bộ lọc khác.', 'Попробуйте другой поиск или фильтр.'],
  closedNow: ['마감', 'Closed', 'Đóng cửa', 'Закрыто'],
  categoryEvent: ['행사', 'Events', 'Sự kiện', 'Мероприятия'],
  categoryEducation: ['교육', 'Education', 'Giáo dục', 'Образование'],
  categoryLeisure: ['레저', 'Leisure', 'Giải trí', 'Досуг'],
  categoryShop: ['쇼핑', 'Shopping', 'Mua sắm', 'Шопинг'],
  categoryLife: ['생활', 'Daily life', 'Đời sống', 'Быт'],
  categoryShoot: ['촬영', 'Shoot', 'Quay chụp', 'Съёмка'],
  categoryDigital: ['디지털', 'Digital', 'Kỹ thuật số', 'Цифра'],
  categoryMart: ['마트', 'Mart', 'Siêu thị', 'Маркет'],
  categoryMedTour: ['의료관광', 'Med tourism', 'Du lịch y tế', 'Медтуризм'],
};

const interior = {
  sortRating: ['별점순', 'By rating', 'Theo điểm', 'По оценке'],
  sortReview: ['후기순', 'By reviews', 'Theo đánh giá', 'По отзывам'],
  sortNewest: ['최신순', 'Newest', 'Mới nhất', 'Новые'],
  sortResponse: ['응답률순', 'By response', 'Theo phản hồi', 'По отклику'],
};

const coworking = {
  filterOpen: ['오픈석', 'Open desk', 'Bàn mở', 'Открытое место'],
  filterPrivate: ['독립석', 'Private desk', 'Chỗ riêng', 'Отдельное место'],
  filterMeeting: ['회의실', 'Meeting room', 'Phòng họp', 'Переговорка'],
  filterBooth: ['폰부스', 'Phone booth', 'Buồng gọi', 'Телефон-будка'],
};

const talent = {
  hubHome: ['집/공간', 'Home / space', 'Nhà / không gian', 'Дом / пространство'],
};

const story = {
  visibility: {
    group: ['모임에게만', 'Group only', 'Chỉ nhóm', 'Только группа'],
  },
};

const chat = {
  room: {
    replyAction: ['답장', 'Reply', 'Trả lời', 'Ответить'],
  },
};

const bookingPkg = {
  title: ['패키지 예약', 'Book package', 'Đặt gói', 'Бронь пакета'],
  needDates: ['날짜를 입력해 주세요.', 'Please pick dates.', 'Hãy chọn ngày.', 'Укажите даты.'],
  needLogin: ['로그인이 필요합니다.', 'Please sign in.', 'Cần đăng nhập.', 'Нужен вход.'],
  duplicate: ['이미 접수된 예약입니다.', 'This booking already exists.', 'Đơn này đã có.', 'Бронь уже есть.'],
  submitted: ['예약이 접수되었습니다. 결제를 완료해 주세요.', 'Booking received. Please complete payment.', 'Đã nhận đơn. Hãy thanh toán.', 'Заявка принята. Оплатите.'],
  fail: ['예약에 실패했습니다.', 'Booking failed.', 'Đặt chỗ thất bại.', 'Не удалось забронировать.'],
  timesPeople: ['{n}명', '{n} guests', '{n} người', '{n} чел.'],
  party: ['인원', 'Guests', 'Số người', 'Гости'],
  startDate: ['출발일', 'Start date', 'Ngày đi', 'Дата выезда'],
  endDate: ['종료일', 'End date', 'Ngày về', 'Дата возврата'],
  requests: ['요청사항', 'Requests', 'Yêu cầu', 'Пожелания'],
  requestsPh: ['알레르기, 픽업 장소 등', 'Allergies, pickup, etc.', 'Dị ứng, điểm đón…', 'Аллергии, трансфер…'],
  payHint: ['결제는 30분 이내에 완료해 주세요. 미결제 시 자동 취소됩니다.', 'Pay within 30 minutes or the hold cancels.', 'Thanh toán trong 30 phút, nếu không sẽ huỷ.', 'Оплатите за 30 минут, иначе отмена.'],
  submitting: ['접수 중…', 'Submitting…', 'Đang gửi…', 'Отправка…'],
  submit: ['예약 접수', 'Submit booking', 'Gửi đặt chỗ', 'Отправить бронь'],
};

const roomsDash = {
  title: ['객실 관리', 'Rooms', 'Phòng', 'Номера'],
  sub: ['{name} · 객실 타입별 상품', '{name} · room types', '{name} · loại phòng', '{name} · типы номеров'],
  add: ['+ 객실 추가', '+ Add room', '+ Thêm phòng', '+ Добавить номер'],
  empty: ['등록된 객실이 없어요', 'No rooms yet', 'Chưa có phòng', 'Номеров пока нет'],
  emptySub: ['객실 타입마다 가격·수용 인원을 설정할 수 있어요', 'Set price and occupancy per room type', 'Đặt giá và sức chứa từng loại phòng', 'Цена и вместимость по типу номера'],
  first: ['첫 객실 등록', 'Add first room', 'Đăng phòng đầu', 'Добавить первый номер'],
  perNight: ['/ 박', '/ night', '/ đêm', '/ ночь'],
  stats: ['조회 {views} · 문의 {inquiries} · 예약 {bookings}', 'Views {views} · Inquiries {inquiries} · Bookings {bookings}', 'Xem {views} · Hỏi {inquiries} · Đặt {bookings}', 'Просм. {views} · Запросы {inquiries} · Брони {bookings}'],
  view: ['보기', 'Open', 'Xem', 'Открыть'],
};

function buildLang(i) {
  return {
    shorts: pick(shorts, i),
    payPage: pick(payPage, i),
    restaurant: pick(restaurant, i),
    local: pick(local, i),
    interior: pick(interior, i),
    coworking: pick(coworking, i),
    talent: pick(talent, i),
    story: pick(story, i),
    chat: pick(chat, i),
    bookingPkg: pick(bookingPkg, i),
    roomsDash: pick(roomsDash, i),
  };
}

export const phaseLiveHangulKo = buildLang(0);
export const phaseLiveHangulEn = buildLang(1);
export const phaseLiveHangulVi = buildLang(2);
export const phaseLiveHangulRu = buildLang(3);
